import React from 'react';
import styles from '../../styles/components/tab/Tabs.module.css';
import { TabContent, TabHeader, TabProps } from './Tab';
import _ from 'lodash';

export interface TabsProps {
  tabs: TabProps[];
  activeTab: string;
  position?: 'left' | 'center' | 'right';
  leftButtons?: JSX.Element[];
  rightButtons?: JSX.Element[];
  onTabChange: (t: string) => void;
}

const Tabs: React.FC<TabsProps> = ({
  tabs,
  activeTab,
  position = 'center',
  leftButtons = [],
  rightButtons = [],
  onTabChange,
}) => {
  const extTabs = tabs.map(tab => ({
    ...tab,
    ...{ active: tab.name === activeTab, onClick: onTabChange },
  }));
  const [headers, contents] = [extTabs.map(TabHeader), extTabs.map(TabContent)];

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.headerContent}>
          {leftButtons && (
            <div className={styles.leftHeaderContent}>
              {_.map(leftButtons, (button, idx) => (
                <div key={idx}>{button}</div>
              ))}
            </div>
          )}
          <div className={styles.centerHeaderContent}>
            <ul className={`${styles[position + 'HeaderTabList']}`}>
              {headers}
            </ul>
          </div>
          {rightButtons && (
            <div className={styles.rightHeaderContent}>
              {_.map(rightButtons, (button, idx) => (
                <div key={idx}>{button}</div>
              ))}
            </div>
          )}
        </div>
      </div>
      <div className={styles.content}>
        <div className={styles.contentList}>{contents}</div>
      </div>
    </div>
  );
};

export default Tabs;
